import React from 'react'
import cn from 'classnames'
import styled from 'react-emotion'
import { themeGet as th } from 'styled-system'
import themeVars from 'ui_theme/site/globals/site.variables'

import { humanFileSize } from 'util/strings'

import styles from './styles.css'

const Header = ({ className, isDesktop, attachments, isUploading }) => {
  if (isDesktop) {
    return (
      <div className={className}>
        <div className="cutout">Attachments</div>
      </div>
    )
  }

  return (
    <div
      className={cn(styles.header, {
        [styles['header-uploading']]: isUploading,
      })}
    >
      <div className={styles.header_title}>Attachments</div>
      <div className={styles.header_total}>
        <div className={cn('Icon Icon-attachment', styles.attachmentIcon)} />
        {isUploading && <div>Uploading</div>}
        {!isUploading && (
          <div>
            {humanFileSize(
              attachments.reduce(
                (totalSize, attachment) => totalSize + attachment.file_size,
                0
              )
            )}
          </div>
        )}
      </div>
    </div>
  )
}

export default styled(Header)`
  display: flex;
  align-items: center;
  margin-bottom: ${th('space.3')}px;
  font-size: ${th('fontSizes.0')}px;
  font-weight: ${th('fontWeights.bold')};
  color: ${th('colors.lightBlue3')};

  &:after {
    content: '';
    height: 1px;
    width: 100%;
    background-color: ${th('colors.lightBlue6')};
    z-index: 1;
  }

  .cutout {
    position: relative;
    display: inline-block;
    padding-right: ${th('space.2')}px;
    z-index: 2;
  }

  @media print {
    margin-bottom: ${themeVars.mini};
  }
`
